
// @mui material components
import Grid from "@mui/material/Grid";

// Admin Dashboard React components
import MDBox from "components/MDBox";

// Admin Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MasterCard from "examples/Cards/MasterCard";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Billing page components
import PaymentMethod from "layouts/billing/components/PaymentMethod";
import Invoices from "layouts/billing/components/Invoices";
import BillingInformation from "layouts/billing/components/BillingInformation";
import Transactions from "layouts/billing/components/Transactions";

function Billing() {
  return (
    <>{localStorage.getItem('*Required Cdn')==null?
    window.location.replace('/authentication/sign-in')
    :
    <DashboardLayout>
            <DashboardNavbar />

       <div id="centerME">
      <div className="boxStAc1">
     
     
        <table id='tableAll'>
          <thead>
            <tr>
              <th scope="col">Sr No.</th>
              <th scope="col" >Hotel Name</th>
              <th scope="col" colSpan={'2'}>Hotel Manager Name
                </th>
              <th scope="col">Email</th>
              <th scope="col">Payment ID</th>
              
              <th scope="col">Payment</th>
              
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Sr No.">1</td>
              <td data-label="Intiative">Most Fanmojasifk fk;kjasd; fasjdf asdjf</td>
              <td data-label="ScoreCard Name" colSpan={'2'}>Hotel Manager Name Hotel Manager Name</td>
              <td data-label="Version">meet2hassan02@gmail.com</td>
              <td data-label="Opportunity Score">92304726072</td>
              <td data-label='Availablility' style={{fontSize:15,fontWeight:'bold'}}>
                5$
              </td>
             
            </tr>
          
          </tbody>
        </table>
      </div>
    </div>
    </DashboardLayout>
    }
    </>
  );
}

export default Billing;
